
import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[numbers]'
})
export class NumbersFormatterDirective {

    constructor(public el: ElementRef) {

        this.el.nativeElement.type = "number";
        this.el.nativeElement.onkeypress = (evt) => {
            if (evt.key == 'Backspace') return;
            if (evt.key == 'Delete') return;
            if (evt.key == 'ArrowLeft') return;
            if (evt.key == 'ArrowRight') return;
            if (evt.key == 'ArrowUp') return;
            if (evt.key == 'ArrowDown') return;
            if (evt.key == 'Home') return;
            if (evt.key == 'End') return;

            if (evt.which < 48 || evt.which > 57) {
                evt.preventDefault();
            }
        };

    }
}


// WEBPACK FOOTER //
// ./src/app/exa/_directives/numbers-formatter.directive.ts